import React from 'react';
import ProSideBar from '../Navigation/ProSideBar';
import ConfirmationOfReceipt from '../../PersonalOffice/ConfirmationOfReceipt/ConfirmationOfReceipt';
import MainRoutes from '../../routes/MainRoutes';

const Main: React.FC = () => {
	return (
		<main className="page">
			<div className="page__container container">
				<ProSideBar />
				<MainRoutes />
				<ConfirmationOfReceipt />
			</div>
		</main>
	);
};

export default Main;
